export const heroSlides = [
  {
    id: "slide-0",
    eyebrow: "X9 PRO BRAND FILM",
    title: "속도 위에 펼쳐지는 X9 PRO",
    subtitle: "라이딩의 감각과 X9 PRO의 디자인을 담아낸 브랜드 필름",
    ctaLabel: "제품 상세보기",
    video:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/e5826915-78a3-4dd8-bfb0-34af9e934358_x9pro-hero.mp4",
  },
  {
    id: "slide-1",
    eyebrow: "NEW · 2026 FLAGSHIP",
    title: "라이딩의 소리를 다시 정의하다",
    subtitle: "X9 PRO 라이더를 위한 프리미엄 헬멧 블루투스 통신 장비",
    ctaLabel: "제품 상세보기",
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/73338ce3-edff-4d21-a20e-0fdb6f8a63b3_compressed_ChatGPT-Image-2026-8-1--04_26_45.webp",
  },
  {
    id: "slide-2",
    eyebrow: "AI NOISE CANCEL",
    title: "바람을 지우고, 목소리만 남기다",
    subtitle: "듀얼 마이크와 AI 노이즈 캔슬링으로 200km/h 주행에서도 선명한 통화",
    ctaLabel: "제품 상세보기",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20cinematic%20shot%20of%20motorcycle%20helmet%20with%20wind%20streaks%20flowing%20past%2C%20dramatic%20blue%20and%20orange%20rim%20lighting%20on%20matte%20black%20helmet%2C%20small%20discreet%20bluetooth%20intercom%20device%20visible%20on%20the%20side%2C%20highway%20motion%20blur%20in%20the%20background%2C%20moody%20dark%20automotive%20studio%20lighting%2C%20editorial%20photography%2C%20cinematic%20color%20grading%20with%20warm%20accent%20light&width=1800&height=1000&seq=ridevox-hero-02&orientation=landscape",
  },
  {
    id: "slide-3",
    eyebrow: "BLUETOOTH 5.4",
    title: "복잡한 도심에서도 끊김 없이",
    subtitle: "Bluetooth 5.4로 스마트폰과 안정적으로 연결해 통화와 내비게이션 안내를 선명하게 전달합니다",
    ctaLabel: "제품 상세보기",
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/cdfe8942-8494-4b0e-8dc9-4e264b07b9c7_compressed_ChatGPT-Image-2026-8-1--04_37_16.webp",
  },
];

export const trustBadges = [
  { label: "IP67 WATERPROOF" },
  { label: "BLUETOOTH 5.4" },
  { label: "K-STARTUP AWARD" },
  { label: "MADE FOR RIDERS" },
];

export const productHighlights = [
  {
    id: "bt54",
    tag: "BLUETOOTH 5.4 CORE",
    title: "초고속 Bluetooth 5.4",
    body: "차세대 무선 프로토콜을 통한 압도적인 연결 속도와 음질 전송력. 전력 소모를 40% 절감하여 안정성을 극대화합니다.",
    icon: "ri-bluetooth-line",
    bullets: ["듀얼 칩셋 아키텍처", "다중 멀티포인트 연결", "끊김 없는 실시간 스트리밍"],
  },
  {
    id: "hifi",
    tag: "HIGH-DEFINITION AUDIO",
    title: "고해상도 HD 스피커",
    body: "40mm 구경의 프리미엄 Hi-Fi 스테레오 스피커 탑재. 풍부한 저음과 명료한 고음을 고속 주행 중에도 온전히 전달합니다.",
    icon: "ri-headphone-line",
    bullets: ["40mm Hi-Fi 드라이버", "하만카돈 스타일 커스텀 튜닝", "고출력 앰프 기본 내장"],
  },
  {
    id: "anc",
    tag: "HYBRID ANC & ENC",
    title: "AI 하이브리드 노이즈 캔슬링",
    body: "주변 풍절음과 배기음을 실시간 감지하여 상쇄합니다. 고속 주행 중에도 고요하고 선명한 통화 품질을 보장합니다.",
    icon: "ri-mic-2-line",
    bullets: ["스마트 듀얼 마이크 캔슬링", "풍절음 디텍션 알고리즘", "보이스 레벨링 기술"],
  },
  {
    id: "battery",
    tag: "ULTRA-LONG ENDURANCE",
    title: "대용량 배터리",
    body: "1,000mAh 대용량 배터리와 전력 최적화 회로 설계. 단 2시간 이하 충전으로 온종일 라이딩에 동반할 수 있습니다.",
    icon: "ri-battery-2-charge-line",
    bullets: ["대용량 1,000mAh 탑재", "연속 통화 최대 15시간 이상", "오디오 재생 환경에 따라 사용 시간 상이"],
  },
  {
    id: "ip67",
    tag: "IP67 DUST & WATERPROOF",
    title: "IP67 등급 방진·방수 설계",
    body: "우천시 습기 속에서도 흔들림 없는 동작. 구조적 완전 방수 설계로 실리콘 하우징 처리되어 내부 기판을 완벽히 보호합니다.",
    icon: "ri-drop-line",
    bullets: ["본체 IP67 등급 방진 및 방수", "전 방향 침투 제어 밀폐", "일상 생활 방수 지원"],
  },
  {
    id: "design",
    tag: "LUXURY PERFORMANCE DESIGN",
    title: "라이딩을 더욱 품격 있게",
    body: "세련된 실루엣과 정교한 디테일이 조화를 이루는 디자인. 헬멧과 자연스럽게 어우러지며 프리미엄 라이딩의 완성도를 높여줍니다.",
    icon: "ri-shining-line",
    bullets: ["럭셔리 명품 고급 컬러", "간편한 버튼 조작", "RGB LED 조명"],
  },
];

export const lifestyleCards = [
  {
    id: "solo",
    title: "홀로 달리는 아침",
    body: "출근길, 좋아하는 플레이리스트가 헬멧 안을 채운다.",
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/f233813d-7ed6-4014-a164-a779c86c13f0_compressed_ChatGPT-Image-2026-8-1--04_56_56.webp",
  },
  {
    id: "tour",
    title: "함께 떠나는 투어링",
    body: "여섯 명의 목소리가 하나로 연결되는 순간.",
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/3dedad5f-28f0-4cbf-bb93-8302d992de50_compressed_ChatGPT-Image-2026-8-1--04_56_30.webp",
  },
  {
    id: "delivery",
    title: "일하는 라이더의 하루",
    body: "고객 전화도, 배차 알림도, 헬멧을 벗지 않고.",
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/00b9c3ed-40ef-4c86-ba6a-b64b2164c432_compressed_5b6687cc-e80f-4d00-bf24-66635db57913.webp",
  },
  {
    id: "night",
    title: "밤을 가르는 라이딩",
    body: "노이즈 캔슬링이 만드는 조용한 몰입감.",
    image:
      "https://readdy.ai/api/search-image?query=Motorcycle%20rider%20at%20night%20on%20a%20highway%20with%20streaks%20of%20warm%20amber%20city%20lights%20blurred%20in%20the%20background%2C%20wearing%20a%20black%20full%20face%20helmet%20with%20visible%20bluetooth%20intercom%20on%20the%20side%2C%20cinematic%20moody%20night%20photography%2C%20soft%20warm%20street%20light%2C%20simple%20dark%20clean%20composition%2C%20editorial%20automotive%20lifestyle&width=900&height=1100&seq=ridevox-life-04&orientation=portrait",
  },
];

export const specGroups = [
  {
    title: "오디오",
    items: [
      { label: "스피커", value: "φ40mm Hi-Fi 스피커" },
      { label: "마이크", value: "2-in-1 교체형 마이크" },
      { label: "헬멧 호환", value: "풀페이스 · 오픈페이스" },
    ],
  },
  {
    title: "연결성",
    items: [
      { label: "블루투스 버전", value: "5.4" },
      { label: "연결 거리", value: "10m 이하" },
      { label: "안내음 음성", value: "영어" },
    ],
  },
  {
    title: "배터리",
    items: [
      { label: "용량", value: "1,000mAh 리튬 폴리머" },
      { label: "작동 시간", value: "15시간 이상 (RGB OFF · 최대 볼륨 기준)" },
      { label: "충전", value: "5V / 1A · 2시간 이하" },
    ],
  },
  {
    title: "본체",
    items: [
      { label: "방수 등급", value: "IP67" },
      { label: "무게", value: "64g (±5g)" },
      { label: "크기", value: "92 × 48 × 25mm" },
    ],
  },
];

export const packageItems = [
  {
    id: "main",
    label: "X9 PRO 본체",
    qty: 1,
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/6fc8fb5a-237f-4bdd-b50e-26010c8eab66_compressed_ChatGPT-Image-2026-8-1--03_48_02.webp",
    detailDesc: "마그네틱 배틀쉘 탈부착 방식의 프리미엄 본체. IP67 완전 방수.",
  },
  {
    id: "speaker",
    label: "40mm HD 스피커 클램프 일체형",
    qty: 1,
    unit: "Pair",
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/942ca528-aded-41e4-b2e1-0099ebb4aa56_compressed_ChatGPT-Image-2026-8-1--03_58_23.webp",
    detailDesc: "40mm 하이파이 다이나믹 드라이버. 귀에 밀착되는 인체공학적 설계.",
  },
  {
    id: "manual",
    label: "사용 설명서",
    qty: 1,
    detailImage: `${__BASE_PATH__}images/package-03-user-manual-original.webp`,
    detailDesc: "한국어/영문 사용 설명서. QR코드로 디지털 매뉴얼 즉시 확인.",
  },
  {
    id: "usb",
    label: "USB Type-C 충전 케이블",
    qty: 1,
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/c42e5073-21fb-4dbb-932a-2521b469750d_compressed_ChatGPT-Image-2026-8-1--03_31_18-6.webp",
    detailDesc: "고속 충전 지원 USB-C 케이블. 내구성 높은 편조 케이블.",
  },
  {
    id: "mic-boom",
    label: "붐 마이크 (하프, 시스템 헬멧용)",
    qty: 1,
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/796942c0-feb6-480c-9e60-afe82d6af334_compressed_ChatGPT-Image-2026-8-1--03_31_18-7.webp",
    detailDesc: "오픈페이스·시스템 헬멧용 붐 마이크. 유연한 조절 암으로 입 위치에 맞춤.",
  },
  {
    id: "mic-wire",
    label: "와이어 마이크 (풀페이스용)",
    qty: 1,
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/adc9071e-11c9-4a80-9756-03f742aacb3c_compressed_ChatGPT-Image-2026-8-1--03_31_18-8.webp",
    detailDesc: "풀페이스 헬멧용 와이어 마이크. 내피 사이에 깔끔하게 매립.",
  },
  {
    id: "spring",
    label: "클램프 고정 스프링",
    qty: 1,
    detailImage:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/37a155b2-4838-49b1-8991-09bdfccbc9e2_compressed_ChatGPT-Image-2026-8-1--03_31_17-4.webp",
    detailDesc: "베이스 클램프 고정용 스프링. 헬멧 두께에 맞춰 유연하게 조절.",
  },
  {
    id: "velcro",
    label: "벨크로, 마이크 솜",
    qty: 4,
    detailImage: `${__BASE_PATH__}images/package-08-velcro-mic-foam.png`,
    detailDesc: "스피커 고정용 벨크로 3매 + 마이크 풍절음 방지 솜 1매.",
  },
  {
    id: "pad",
    label: "스피커 패드",
    qty: 4,
    detailImage: `${__BASE_PATH__}images/package-09-speaker-pads-4.png`,
    detailDesc: "스피커 두께 조절용 패드 4매. 귀에 완벽히 밀착되도록 두께 커스터마이징.",
  },
];

type BuyStore = {
  id: string;
  name: string;
  city: string;
  type: "Online" | "Offline";
  phone?: string;
  url?: string;
};

export const buyStores: BuyStore[] = [
  {
    id: "bupyeong",
    name: "인천 부평점(본점)",
    city: "인천광역시 부평구 경인로 1083",
    type: "Offline",
    phone: "032-668-8723",
  },
  {
    id: "siheung",
    name: "바이크일번지 시흥점",
    city: "경기도 시흥시 군서마을로 116 102호 바이크뱅크",
    type: "Offline",
    phone: "010-3887-1526",
  },
  {
    id: "geomdan",
    name: "바이크일번지 검단점",
    city: "인천광역시 검단구 봉수대로 1290",
    type: "Offline",
    phone: "0507-1430-9445",
  },
  {
    id: "bike-street-bucheon",
    name: "바이크일번지 부천점",
    city: "경기도 부천시 원미로201번길 72 1층",
    type: "Offline",
    phone: "0507-1326-8723",
  },
  {
    id: "iryun-sangsa",
    name: "이륜상사",
    city: "인천광역시 남동구 백범로 309 KR모터스",
    type: "Offline",
    phone: "0507-1333-5586",
  },
  {
    id: "rpm-bike-bucheon",
    name: "RPM바이크",
    city: "경기도 부천시 원미구 부일로 396 1층",
    type: "Offline",
    phone: "0507-1318-8278",
  },
  {
    id: "rpm-bike-wonjong",
    name: "RPM바이크(원종점)",
    city: "경기도 부천시 오정구 원종로 92",
    type: "Offline",
    phone: "0507-1475-1106",
  },
  {
    id: "raon-motorcycle",
    name: "라온오토바이",
    city: "경기도 부천시 소사구 소사로 135",
    type: "Offline",
    phone: "032-345-6465",
  },
  {
    id: "bike-story-bucheon",
    name: "바이크스토리",
    city: "경기도 부천시 원미구 장말로 331-1",
    type: "Offline",
    phone: "032-207-2222",
  },
  {
    id: "one-in-the-park-bucheon",
    name: "원인더파크(구 지피바이크)",
    city: "경기도 부천시 원미구 길주로 352-1 1층",
    type: "Offline",
    phone: "0507-1445-8073",
  },
  {
    id: "jung-motors-yeongjong",
    name: "정모터스",
    city: "인천광역시 영종구 모랫말로16번길 13-19 1층 101호",
    type: "Offline",
    phone: "010-4702-9760",
  },
  {
    id: "yamaha-dongdaemun",
    name: "야마하 동대문점",
    city: "서울특별시 동대문구 천호대로 48 1층",
    type: "Offline",
    phone: "02-6212-5333",
  },
];

export const faqItems = [
  {
    q: "본사에서 제품을 직접 구매할 수 있나요?",
    a: "안녕하세요, 소비자 대상으로 직접 판매(직판)를 진행하지 않고 있습니다. 공식 판매점(대리점)을 확인 후 이용해 주시기 바랍니다.",
  },
  {
    q: "헬멧 브랜드나 형태(풀페이스, 오픈페이스, 시스템 등)에 제약이 없나요?",
    a: "대부분의 헬멧에 호환됩니다. 패키지에 붐 마이크와 와이어 마이크가 함께 제공되어 헬멧 종류에 맞춰 선택할 수 있습니다.",
  },
  {
    q: "우천시 사용이 가능한가요?",
    a: "IP67 등급으로 완전 방수·방진을 지원합니다. 폭우 라이딩과 세차 시에도 안전하지만, 물속에 장시간 담그는 것은 피해주세요.",
  },
  {
    q: "전원을 다시 켰을 때 블루투스를 재연결해야 하는 이유는 무엇인가요?",
    a: "소프트웨어 불량이 아닙니다. 전원을 켜거나 끌 때는 반드시 M 버튼과 기능 버튼을 동시에 눌러야 합니다. 전원을 끌 때 기능 버튼이 함께 눌리지 않고 M 버튼만 3초 이상 눌리면 블루투스 페어링이 강제로 해제될 수 있습니다. 이 상태에서 다시 전원을 켜면 기존 연결 정보가 해제되어 블루투스를 다시 페어링해야 합니다. 정상적인 사용을 위해 전원을 켜고 끌 때 항상 M 버튼과 기능 버튼을 동시에 눌러주세요.",
  },
  {
    q: "통화 중 다른 전화가 오면 자동으로 연결되나요?",
    a: "대기통화 자동 연결 기능이 활성화되어 있으면 통화 중 제3자의 전화가 올 때 자동으로 연결될 수 있습니다. 기능을 해제하려면 조명(RGB) 버튼을 2~3초간 길게 눌러주세요. 같은 버튼을 다시 2~3초간 길게 누르면 기능이 다시 활성화됩니다. 조명(RGB) 버튼을 2~3초간 길게 눌러 대기통화 자동 연결 기능을 ON/OFF할 수 있습니다.",
  },
  {
    q: "구매 후 국내 공식 무상 보증 및 A/S 처리는 어떻게 되나요?",
    a: "구매일로부터 1년간 정상적인 사용 중 발생한 본체 회로 고장은 무상 A/S 또는 본체 교체로 처리해 드립니다. 스피커와 마이크는 구매일로부터 6개월간 제품 자체 불량에 한해 무상 A/S를 제공합니다. 클램프, 벨크로 및 패드 등의 소모품은 초기 불량에 한해 구매 후 1개월간 지원되며, 이후에는 유상 처리됩니다. 소비자 과실로 인한 파손·침수·임의 분해 및 개조는 무상 보증에서 제외됩니다.",
  },
];

export const manualTabs = [
  { id: "intro", label: "제품 소개 & 주요 기능" },
  { id: "pairing", label: "기능 요약 & 블루투스 연결" },
  { id: "install", label: "장착 방법 (베이스/마이크)" },
  { id: "care", label: "보관 및 주의사항" },
  { id: "specs", label: "상세 사양 명세" },
];

export const manualContents: Record<string, { title: string; body: string; bullets?: string[]; image?: string }> = {
  intro: {
    title: "최고의 고음질 라이딩 파트너",
    body: "X9 PRO는 헬멧 측면에 장착하여 사용하는 최고 스펙 탑재 라이딩 블루투스 헤드셋입니다. 고품질 오디오 복원(High-fidelity audio restoration) 스피커를 채택하여 Hi-Fi급의 정밀한 명품 음질을 구현하며, 라이더에게 더욱 여유롭고 안전한 라이딩 감성을 선사합니다.",
    bullets: [
      "블루투스 5.4 핵심 칩셋 — 더 길어진 연결성, 초 저지연 전송 및 배터리 전력 효율 40% 절감",
      "듀얼 기기 동시 연결(멀티포인트) — 스마트폰 2대 혹은 스마트폰 + GPS 수신기를 끊김 없이 실시간 대기 연결",
      "Hi-Fi 초고음질 스피커 — 주행 노이즈를 뚫고 귓가에 고해상도 사운드를 선사하는 40mm 드라이버",
      "2-in-1 탈부착 마이크 — 오픈페이스용 붐 마이크와 풀페이스용 와이어 마이크 모두 패키지 기본 제공",
      "IP67 최고 등급 방진·방수 — 우천시 주행이나 눈길에서도 빈틈없는 완전 밀폐 안전성 보장",
      "자석식 프리미엄 배틀쉘 — 탈부착이 부드럽고 견고한 고화질 마그네틱 이온 배틀쉘 디자인",
    ],
    image:
      "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/31d09a4c-72c4-4755-a257-a221aed01b71_compressed_ChatGPT-Image-2026-8-1--05_09_26.webp",
  },
  pairing: {
    title: "기능 요약 & 블루투스 연결",
    body: "X9 PRO는 간편한 버튼 조작으로 통화, 음악, 음성 비서 기능을 제어할 수 있습니다. 첫 연결 시 스마트폰의 블루투스 설정에서 'X9 PRO'를 선택하세요.",
    bullets: [
      "정상 전원 켜기/끄기 — M 버튼과 기능 버튼을 반드시 동시에 누르기",
      "페어링 해제 주의 — 기능 버튼 없이 M 버튼만 3초 이상 누르면 블루투스 연결 정보가 강제로 해제될 수 있음",
      "재연결 안내 — 페어링이 해제된 상태에서 다시 켜면 스마트폰에서 X9 PRO를 다시 연결해야 하며, 이는 소프트웨어 불량이 아님",
      "볼륨 조절 — 볼륨 업/다운 버튼 짧게 누르기",
      "통화 수신/종료 — 전원 버튼 짧게 누르기",
      "대기통화 자동 연결 ON/OFF — 조명(RGB) 버튼을 2~3초간 길게 누르기",
      "음성 비서 호출 — 볼륨 다운 버튼 길게 누르기",
      "듀얼 페어링 — 두 대의 기기를 동시에 연결하여 음악과 내비게이션을 동시에 사용",
    ],
  },
  install: {
    title: "장착 방법 (베이스/마이크)",
    body: "전문 엔지니어의 도움 없이도 단 10분 만에 헬멧에 완벽히 피팅할 수 있습니다. 클립으로 먼저 사용해 보신 후, 위치가 확정되면 접착형 브라켓을 사용하시길 권장합니다.",
    bullets: [
      "베이스(거치대) 설치 — 클립 마운트 또는 3M 접착 마운트 중 선택해 헬멧 측면에 고정",
      "스피커 설치 — 헬멧 내부 귀 위치에 스피커 패드를 덧대고 스피커를 배치",
      "마이크 설치 — 헬멧 종류에 맞춰 붐 마이크(오픈/시스템) 또는 와이어 마이크(풀페이스) 선택",
      "본체 결합 — 마그네틱 배틀쉘로 본체를 베이스에 부드럽게 탈착",
    ],
  },
  care: {
    title: "보관 및 주의사항",
    body: "제품을 안전하게 사용하고 성능을 오래 유지할 수 있도록 아래의 보관 및 관리 사항을 지켜주세요.",
    bullets: [
      "서늘하고 건조한 곳에 보관해 주세요.",
      "화기·열원·가연성 가스·세척성 또는 부식성 액체에서 멀리하고, 장시간 직사광선이나 고온에 노출하지 마세요.",
      "제품이 파손되거나 연기, 과열 또는 타는 냄새가 발생하면 즉시 사용을 중단해 주세요.",
      "IP67 등급의 방진·생활 방수를 지원하지만 완전 방수 제품은 아닙니다. 물에 담그지 말고, 마모와 노후화로 방수 성능이 저하될 수 있으니 주의해 주세요.",
      "헤드셋과 충전 케이블은 어린이와 반려동물의 손이 닿지 않는 곳에 보관해 주세요. 삼킴 사고가 발생하면 즉시 의사의 진료를 받으세요.",
      "제품을 청소할 때는 부드럽고 마른 천을 사용해 주세요.",
      "장기간 보관한 제품을 다시 사용할 때는 배터리를 완전히 충전한 후 사용해 주세요.",
    ],
  },
  specs: {
    title: "상세 사양 명세",
    body: "X9 PRO의 모든 기술적 스펙을 한눈에 확인하세요.",
    bullets: [
      "블루투스: Bluetooth 5.4 / 연결 거리 10m 이하",
      "스피커: φ40mm Hi-Fi 스피커",
      "마이크: 2-in-1 교체형 마이크 (풀페이스 / 오픈페이스)",
      "배터리: 1,000mAh 리튬 폴리머 / 작동 시간 15시간 이상",
      "충전: 5V / 1A / 2시간 이하",
      "방수: IP67 등급",
      "무게: 64g (±5g)",
      "크기: 92 × 48 × 25mm",
    ],
  },
};

export const installSteps = [
  {
    id: 1,
    title: "베이스(거치대) 설치 방법",
    desc: "헬멧 형태에 맞춰 접착형 베이스 또는 클립형 베이스를 선택하여 설치합니다.",
    image: `${__BASE_PATH__}images/install-01-base.png`,
    tips: [
      "접착형은 베이스 뒷면의 양면테이프 보호 필름을 제거한 뒤 헬멧 왼쪽 측면에 부착합니다.",
      "클립형은 헬멧 왼쪽 측면 테두리에 백클립을 끼워 단단히 고정합니다.",
      "본체를 베이스의 자석 위치에 가까이 대면 ‘착’ 소리와 함께 고정됩니다.",
    ],
  },
  {
    id: 2,
    title: "오픈페이스·시스템 헬멧 설치",
    desc: "하프페이스용 마이크를 사용하여 스피커와 마이크를 설치합니다.",
    image: `${__BASE_PATH__}images/install-02-open-system.png`,
    tips: [
      "스피커용 벨크로의 보호 필름을 제거하고 헬멧 내부 좌우 귀 홈에 부착합니다.",
      "케이블이 긴 스피커는 헬멧 우측, 짧은 스피커는 헬멧 좌측에 고정합니다.",
      "마이크용 벨크로는 왼쪽 치크패드 안쪽의 잘 보이지 않는 곳에 부착합니다.",
      "마이크와 입 사이의 거리는 약 1~2cm를 유지하고 케이블은 내피 안으로 정리합니다.",
    ],
  },
  {
    id: 3,
    title: "풀페이스 헬멧 설치",
    desc: "풀페이스용 마이크를 사용하여 스피커와 마이크를 설치합니다.",
    image: `${__BASE_PATH__}images/install-03-fullface.png`,
    tips: [
      "스피커용 벨크로의 보호 필름을 제거하고 헬멧 내부 좌우 귀 홈에 부착합니다.",
      "케이블이 긴 스피커는 헬멧 우측, 짧은 스피커는 헬멧 좌측에 고정합니다.",
      "마이크용 벨크로를 턱 안쪽 정면에 부착하고 입과 1~2cm 거리를 유지합니다.",
      "케이블을 내피 안쪽으로 깔끔하게 정리하여 설치를 마무리합니다.",
    ],
  },
];
